module.exports = __webpack_public_path__ + "img/2whale.18b28e4c.png";